import React from "react";
import Layout from "../components/layout/layout";
import PreParser from "../components/preParser";
const Page = (props) => {
    const page = props.isPreview ? props : props.data.wpPage;
    return (React.createElement(Layout, { data: props.data, infos: {
            title: page.title,
            postType: "page",
            path: props.pageContext.path,
            parents: props.pageContext.parents,
        }, seo: page.seo || {} },
        React.createElement(PreParser, { structure: page.jsonContent })));
};
export default Page;
